import axios from "../../config/axiosConfig";
import {
  GSTR3B_REPORT_REQUEST,
  GSTR3B_REPORT_SUCCESS,
  GSTR3B_REPORT_FAILURE,
} from "../types/gstr3b-report-types";

export const getGSTR3bReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GSTR3B_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };
    
      const requestParams = { ...defaultParams, ...params };
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/gstr3b-report/getReport?${queryString}`;
      console.log('Complete GSTR3B API Request URL: ', fullUrl);
      return axios.get('/gstr3b-report/getReport', { params: requestParams }).then((response) => {
        if (response) {
          dispatch({ 
            type: GSTR3B_REPORT_SUCCESS, 
            payload: response 
          });
          console.log("Actions Api Call" , response);
          
          return response;
        } else {
          throw new Error(response.data?.message || 'Failed to fetch GSTR2 report');
        }
      }).catch((error) => {
        console.error("Error fetching GSTR3B Report:", error);
        dispatch({ 
          type: GSTR3B_REPORT_FAILURE, 
          error: error.response?.data?.message || error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error("Error fetching GSTR3B Report:", error);
      dispatch({ 
        type: GSTR3B_REPORT_FAILURE, 
        error: error.response?.data?.message || error.message 
      });
      throw error;
    }
  };
};
